module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAAXNSR0IArs4c6QAAAJtJREFUGBljlJKSXvD///94BiIAIyPjQiYGBoksoNprRKgHqpHIYgQplJOT0/rz58/p//8ZuLBpZGRk+MbCwmL66NGja8wgBR8/fnzNx8f3DKghAJsGJibGtCdPnuwGyYE1gBifP3++ANSkCGQagPgwAHL3s2dPG2B8oB+QAYZ/wO5GVgH2A7IAzD8gMZi7keWxsqWlpRNAGJskAMdTMaazClPKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/triangle_open@2x.png
// module id = fFj3
// module chunks = 1